<template>
	<div>
		<v-tabs v-model="tab" vertical @change="changeTab">
			<v-tab key="General">{{ $t("general") }}</v-tab>
			<v-tab key="Reg Types">{{
				$t("entities.stageType.tabs.form.regTypes")
			}}</v-tab>
			<v-tabs-items v-model="tab">
				<v-tab-item key="General">
					<v-container>
						<v-form v-model="valid" ref="form">
							<v-text-field
								v-model="value.description"
								label="Description"
								:rules="$isRequiredRule"
							></v-text-field>

							<v-select
								v-model="value.environmentId"
								:items="environments"
								item-text="description"
								item-value="id"
								:label="$t('entities.stageType.props.environmentId')"
								:rules="$isRequiredRule"
							></v-select>
						</v-form>
					</v-container>
				</v-tab-item>
				<v-tab-item key="Reg Types" eager>
					<v-container>
						<v-alert v-if="!value.environmentId" type="error"
							>Environment is required</v-alert
						>
						<list-select
							v-model="value.regTypeIds"
							:loading="loadingTable"
							item-text="description"
							item-value="id"
							:items="items"
							:page="pagination.page"
							@change-page="pagination.page = $event"
							:pageLength="lengthPaginationComp"
							@search="searchTable"
							item-subtitle
							no-search
						>
							<template slot="title" slot-scope="data">
								{{ data.item.description }}
							</template>
							<template slot="subtitle" slot-scope="data">
								{{
									data.item.stageRequired
										? $t("entities.regType.props.stageRequired")
										: null
								}}
							</template>
						</list-select>
						<!-- <table-grid
              ref="tableGrid"
              :headers="headers"
              search-table
              :items="items"
              :loading="loadingTable"
              :loadingAction="loadingDialog"
              :page="pagination.page"
              :pageLength="lengthPaginationComp"
              :multiple="true"
              @change-page="pagination.page = $event"
              :select-items="regTypes"
              @input="updateRegTypeIds"
            /> -->
					</v-container>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>
<script>
	import listSelect from "../../lists/listSelect.vue";
	import pageListMixing from "../../../mixins/pageLists/pageListMixing";
	export default {
		mixins: [pageListMixing],
		components: { listSelect },
		props: {
			value: {
				default() {
					return {
						description: "",
						environmentId: null,

						regTypeIds: [],
					};
				},
			},
		},
		data() {
			return {
				tab: null,
				valid: true,
				apiController: "regType",
				environments: [],
				search: null,
				searchFields: ["description"],
				regTypes: [],
				headers: [
					{
						text: this.$t("entities.regType.props.description"),
						align: "left",
						sortable: false,
						value: "description",
					},
					{
						text: this.$t("entities.regType.props.stageRequired"),
						align: "left",
						sortable: false,
						value: "stageRequired",
						filter: (value) => {
							return value == true ? "Sim" : "Não";
						},
					},
					{
						text: this.$t("entities.regType.props.environmentId"),
						align: "left",
						sortable: false,
						value: "environmentDesc",
					},
				],
			};
		},
		watch: {
			async "value.environmentId"() {
				//this.$refs.tableGrid.clearSelection();
				this.items = [];
				this.$refs.form.resetValidation();
				await this.getItems();
			},
			async value() {
				this.items = [];
				this.$refs.form.resetValidation();
				await this.getItems();
			},
		},

		methods: {
			updateRegTypeIds(regTypes) {
				this.regTypes = regTypes;
				let ids = regTypes.map((regType) => {
					return regType.id;
				});
				this.$emit("changeRegTypeIds", ids);
			},
			isValid() {
				return this.$refs.form.validate();
			},
			changeTab(tab) {
				if (tab == 1) {
					this.updateSelectRegTypeIds();
				}
			},

			removeRegTypesInItemUpdate() {
				let regTypesToRemove = this.regTypes.filter(
					(regType) =>
						this.value.regTypeIds.filter((regTypeId) => regType.id == regTypeId)
							.length == 0
				);
				if (regTypesToRemove.length > 0) {
					regTypesToRemove.forEach((regTypeToRemove) => {
						let index = this.regTypes.indexOf(regTypeToRemove);
						this.regTypes.splice(index, 1);
					});
				}
			},
			updateSelectRegTypeIds() {
				let regTypesInStageType = this.items.filter(
					(regType) =>
						this.value.regTypeIds.filter((regTypeId) => regType.id == regTypeId)
							.length > 0
				);
				this.regTypes = regTypesInStageType;
			},
			async getItems() {
				if (!this.value.environmentId) return;
				this.loadingTable = true;
				this.pagination.limit = 1;
				let res = await this.$http.get(this.apiController + "/s-environment", {
					environmentId: this.value.environmentId,
					page: this.pagination.page,
					limit: this.$rowsLimit,
				});
				if (res.success) {
					res.data.data.forEach((i) => {
						let env = this.environments.filter(
							(e) => e.id == i.environmentId
						)[0];
						i.environmentDesc = env ? env.description : "";
					});

					this.items = res.data.data;
					this.pagination.total = res.data.total;
					this.updateSelectRegTypeIds();
				} else {
					this.errorNotification(res.data);
				}

				this.loadingTable = false;
			},
			selectRow(row) {
				if (this.$refs.tableGrid) this.$refs.tableGrid.selectRow(row);
			},
			async getEnvironments() {
				let res = await this.$http.get("environment");
				if (res.success) this.environments = res.data.data;
			},
		},
		async mounted() {
			await this.getEnvironments();
			await this.getItems();
		},
	};
</script>
